import { render } from "./employee-payslip.vue?vue&type=template&id=424516d9"
import script from "./employee-payslip.vue?vue&type=script&lang=js"
export * from "./employee-payslip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__